define('shoptheme/components/customer/newsletter',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem"
], function(
	$,
	Component,
	BEM
) {
	return Component.create({

		$init: function() {

			this.monitorCheckboxes();
			this.monitorControlCheckbox();

		},
		monitorCheckboxes: function() {
			$("[id*='newsletter-checkbox-Gigaset']").change(function(e, stopPropagation) {
				var allCheck = true,
					checkboxControl = $('#checkbox-control');

				if (stopPropagation) return false;

				$("[id*='newsletter-checkbox-']").each(function (){
					if ($(this).prop('checked')) {
						allCheck = allCheck && true;
					} else {
						allCheck = allCheck && false;
					}
				});

				if (allCheck){
					checkboxControl.prop('checked', 'checked');

				} else {
					checkboxControl.removeProp('checked');
				}

				checkboxControl.trigger("change", true);
			});
		},
		monitorControlCheckbox: function() {
			$('#checkbox-control').change(function (e, stopPropagation) {
				var isChecked = $(this).prop('checked');

				if (stopPropagation) return false;

				$("[id*='newsletter-checkbox-']").each(function (){
					var checkbox = $(this);

					if (isChecked) {
						checkbox.prop('checked', 'checked');
					} else {
						checkbox.removeProp('checked');
					}

					checkbox.trigger("change", true);
				});
			});
		}
	});
});



